import z from "zod";
import { ZodDateString } from "../../zod-types/zod-date-string";

export const postCopyDaySchema = z.object({
	date: ZodDateString,
});

export type PostCopyDaySchema = z.infer<typeof postCopyDaySchema>;
